import { ICustomer } from '../interfaces/customer.interface';
import { ContactBaseModel } from './contact-base.model';

export class CustomerModel extends ContactBaseModel implements ICustomer {}
